import { useSyncExternalStore } from "react";

/**
 * "Share this view" needs every card of the tab ON the page, but most cards
 * below the fold sit in <DeferUntilVisible> and are not mounted until
 * scrolled to. Bumping the epoch tells every deferred wrapper alive right now
 * to mount; wrappers that mount later keep their lazy behaviour.
 */
let epoch = 0;
const listeners = new Set<() => void>();

export function forceMountDeferred(): void {
  epoch += 1;
  listeners.forEach((l) => l());
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export function useForceMountEpoch(): number {
  return useSyncExternalStore(subscribe, () => epoch, () => epoch);
}
